import React from 'react';
import { BriefFitProvider } from './BriefPage';
import { LaunchPageOne } from './LaunchPageOne';
import { BriefPageTwo } from './BriefPageTwo';

/**
 * The two-page D2D Launch proposal for go-to-market clients. Page 2 shares the
 * Partnership Brief's pricing layout, with the leader search always included.
 */
export function LaunchProposal() {
  return <BriefFitProvider data-id="element-824" data-mp="iz8tmed4wt4v">
      <div className="space-y-10" data-id="element-825" data-mp="1gotz0s2gemmk">
        <LaunchPageOne data-id="element-826" data-mp="1go2f4ei7ydc4" />
        <BriefPageTwo variant="launch" data-id="element-827" data-mp="1goc5w4b38oiv" />
      </div>
    </BriefFitProvider>;
}